var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 8.66665H15.3333V15.3333H8.66659V18.6666H15.3333V25.3333H18.6666V18.6666H25.3333V15.3333H18.6666V8.66665ZM16.9999 0.333313C7.79992 0.333313 0.333252 7.79998 0.333252 17C0.333252 26.2 7.79992 33.6666 16.9999 33.6666C26.1999 33.6666 33.6666 26.2 33.6666 17C33.6666 7.79998 26.1999 0.333313 16.9999 0.333313ZM16.9999 30.3333C9.64992 30.3333 3.66659 24.35 3.66659 17C3.66659 9.64998 9.64992 3.66665 16.9999 3.66665C24.3499 3.66665 30.3333 9.64998 30.3333 17C30.3333 24.35 24.3499 30.3333 16.9999 30.3333Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.17d8ef6b89d8d049130a5e64c62c1ce0.svg";
export { ForwardRef as ReactComponent };